import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import casillo from "../../assets/partner/casillo.svg";
import deliziosa from "../../assets/partner/deliziosa.png";
import rossogargano from "../../assets/partner/rossogargano.webp";
import contizecca from "../../assets/partner/contizecca.svg";
import birrasalento from "../../assets/partner/birrasalento.png";
import montedirena from "../../assets/partner/montedirena.png";
import hb from "../../assets/partner/hb.svg";

const brands = [
    { src: casillo, alt: "Casillo" },
    { src: deliziosa, alt: "Deliziosa" },
    { src: montedirena, alt: "Monte Di Riena" },
    { src: rossogargano, alt: "Rosso Gargano" },
    { src: contizecca, alt: "Conti Zecca" },
    { src: birrasalento, alt: "Birra Salento" },
    { src: hb, alt: "HB" },
];

export default function PartnerCarousel() {
    return (
        <section className="py-20 bg-black overflow-hidden border-t border-accent/10">
            <div className="max-w-5xl mx-auto px-6">
                <motion.h2
                    className="text-center text-xl md:text-2xl font-title text-muted mb-12 tracking-wide uppercase font-medium text-opacity-80"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                >
                    Materie Prime Selezionate
                </motion.h2>

                {/* 🚀 SFUMATURA LATERALE NATIVA: Usa mask-image per dissolvere i loghi ai lati in modo perfetto */}
                <div 
                    className="w-full"
                    style={{
                        WebkitMaskImage: "linear-gradient(to right, transparent, white 15%, white 85%, transparent)",
                        maskImage: "linear-gradient(to right, transparent, white 15%, white 85%, transparent)"
                    }}
                >
                    <Swiper
                        slidesPerView={3}
                        spaceBetween={20}
                        loop={true}
                        autoplay={{ delay: 2500, disableOnInteraction: false }}
                        breakpoints={{
                            480: { slidesPerView: 3 },
                            768: { slidesPerView: 5 },
                            1024: { slidesPerView: 6 },
                        }}
                        modules={[Autoplay]}
                        className="flex items-center"
                    >
                        {brands.map((brand, idx) => (
                            <SwiperSlide key={idx} className="flex items-center justify-center my-auto">
                                <div className="h-16 flex items-center justify-center grayscale opacity-40 hover:grayscale-0 hover:opacity-100 transition-all duration-300">
                                    <img
                                        src={brand.src}
                                        alt={brand.alt}
                                        className="max-h-full max-w-[110px] object-contain"
                                        loading="lazy"
                                        draggable={false}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
}